export default function FolderDirective(
  RecursionHelper
) {
  return {
    restrict: 'E',
    template: require('./folder.html'),
    scope: {
      folderList: '=',
      serviceId: '@',
      attachmentTypeId: '@',
      attachmentEntityId: '@',
      parentFolder: '=',
      folder: '=',
      canAddFolder: '@',
      canDeleteFolder: '@',
      canAddDocument: '@',
      canDeleteDocument: '@',
      canAttach: '=',
      fnDocMgmt: '=',
      attachedIds: '=',
      maxAttachments: '@',
      tooltipAppendToSelector: '@',
    },
    controller: 'FolderController',
    controllerAs: 'folderVM',
    bindToController: true,
    replace: true,
    compile(tElem) {
      // eslint-disable-next-line no-unused-vars
      return RecursionHelper.compile(tElem, (scope, iElement, iAttrs, controller, transcludeFn) => {
        // TODO:
      });
    },
  };
}

FolderDirective.$inject = ['RecursionHelper'];
